/**
 * Reviews Scroll Functionality
 * Makes the Reviews.io rating stars at the top of PDP clickable
 * and scrolls down to the main reviews section
 */

class ReviewsScrollHandler {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupScrollHandler());
    } else {
      this.setupScrollHandler();
    }
  }

  setupScrollHandler() {
    let retryCount = 0;
    const maxRetries = 50;
    
    const checkForReviewsBadge = () => {
      retryCount++;
      
      const selectors = [
        '.reviews-io-wrapper',
        '[id*="shopify-block"][id*="reviewsio-rating-output"]',
        '[id*="shopify-block"] .ReviewsBadge',
        '[id*="shopify-block"] [class*="reviews"]',
        '.ruk_rating_snippet'
      ];
      
      let reviewsElement = null;
      
      for (const selector of selectors) {
        reviewsElement = document.querySelector(selector);
        if (reviewsElement) break;
      }
      
      if (reviewsElement) {
        const hasContent = reviewsElement.innerHTML.trim() !== '' || reviewsElement.children.length > 0;
        
        if (hasContent) {
          this.makeClickable(reviewsElement);
        } else if (retryCount < maxRetries) {
          setTimeout(checkForReviewsBadge, 100);
        }
      } else if (retryCount < maxRetries) {
        setTimeout(checkForReviewsBadge, 100);
      }
    };

    checkForReviewsBadge();
  }

  makeClickable(element) {
    element.style.cursor = 'pointer';
    
    element.addEventListener('click', (e) => {
      e.preventDefault();
      this.scrollToReviews();
    });
    
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-label', 'Scroll to customer reviews section');
    
    element.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.scrollToReviews();
      }
    });
  }

  scrollToReviews() {
    const reviewsSection = document.querySelector('.product-reviews__content') || 
                          document.querySelector('.product-reviews') ||
                          document.querySelector('[id*="ReviewsWidget"]');
    
    if (reviewsSection) {
      const headerOffset = this.getHeaderOffset();
      const elementPosition = reviewsSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      setTimeout(() => {
        reviewsSection.setAttribute('tabindex', '-1');
        reviewsSection.focus({ preventScroll: true });
      }, 500);
    }
  }

  getHeaderOffset() {
    const stickyHeader = document.querySelector('sticky-header');
    return stickyHeader ? stickyHeader.offsetHeight + 20 : 20;
  }
}

// Initialize the reviews scroll handler
new ReviewsScrollHandler();